"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyChecklistItemActionEnum = void 0;
var MonthlyChecklistItemActionEnum;
(function (MonthlyChecklistItemActionEnum) {
    MonthlyChecklistItemActionEnum[MonthlyChecklistItemActionEnum["Include"] = 1] = "Include";
    MonthlyChecklistItemActionEnum[MonthlyChecklistItemActionEnum["Skip"] = 2] = "Skip";
})(MonthlyChecklistItemActionEnum = exports.MonthlyChecklistItemActionEnum || (exports.MonthlyChecklistItemActionEnum = {}));
exports.default = MonthlyChecklistItemActionEnum;
